export default __webpack_public_path__ + "static/luna-612ce2e7d9fb880f117a0083b9c9d639.png";